import { InstanceEnvironment } from '../features/sign-in/types/InstanceEnvironment';

export const getInstanceError = (env: InstanceEnvironment): string | null => {
  if (env.maintenanceMode) {
    return 'login.instanceUnderMaintenance';
  }

  return null;
};
